import React, { useEffect } from "react";
import { Form, Input, InputNumber, Select, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getJobRoleRequestDetails, 
	doJobRoleRequestCreate, 
	doJobRoleRequestUpdate 
} from "../../../../redux/jobrolerequest/jobRoleRequestState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import DynamicList from "components/fields/DynamicList";
import { getLabel } from "utils";
import { MODULE_JOBROLE_REQS, DATE_FORMAT } from "variables/constants";
import dayjs from "dayjs";

const JobRoleForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;
	const { TextArea } = Input;  	

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);


	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { job_role:jobRole, jrr_job_role_id, ...rest } = recordData;

			const initialValues = {
				...rest,
				...jobRole,
				jrr_id: recordData?.jrr_id ?? "",
				jrr_target_date: recordData?.jrr_target_date ? dayjs(recordData.jrr_target_date) : null,

				jro_job_title: jobRole?.jro_job_title ?? "",
				jro_count: jobRole?.jro_count ?? "",

				jro_key_responsibilities: Array.isArray(jobRole?.jro_key_responsibilities)
					? recordData.job_role.jro_key_responsibilities
					: recordData.job_role.jro_key_responsibilities
					? JSON.parse(recordData.job_role.jro_key_responsibilities)
					: [""],
				jro_preferred_qualifications: Array.isArray(jobRole?.jro_preferred_qualifications)
					? recordData.job_role.jro_preferred_qualifications
					: recordData.job_role.jro_preferred_qualifications
					? JSON.parse(recordData.job_role.jro_preferred_qualifications)
					: [""],
			};	
	        form.setFieldsValue(initialValues);

        }
    }, [recordData, form]);


  	const onSubmit = (formData) => {	
		console.log(formData);
    	try {  
			formData.jrr_target_date= formData.jrr_target_date.format(`${DATE_FORMAT}`);

			recordData.jrr_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className="form"
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="jrr_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>

			<FormItem
				name="jrr_job_role_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>

			<div>

			</div>
			<div className="grid grid-cols-7 gap-y-2 gap-x-4 w-full">
				
				<FormItem className="font-medium mb-2 col-span-2"
					name="jrr_status_id"
					label="Request Status"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<Select id="jrr_status_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.jobRequestStatusList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.jobRequestStatusList, recordData?.jrr_status_id)}
						</label>
					}	                
				</FormItem>

				<FormItem className="font-medium mb-2 col-span-5"
					name="jro_job_title"
					label="Job Title"
					rules={[requiredField()]}
					
				>
					{mode !== 'view' ?
						<Input id="jro_job_title"
							className="input-field"
							maxLength={100}
							placeholder="Enter job title"
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.job_role?.jro_job_title}
						</label>
					}
				</FormItem>
			</div>
			
			<div className="grid grid-cols-5 gap-y-2 gap-x-4 w-full">         
				<FormItem className="font-medium mb-2 col-span-1"
					name="jro_count"
					label="Count"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<InputNumber id="jro_count"
							className="input-field"
							type="text"
							placeholder="1"
							min={1}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.job_role?.jro_count}
						</label>
					}                
				</FormItem>
				<FormItem className="font-medium mb-2 col-span-2"
					name="jro_job_level_id"
					label="Job Level"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<Select id="jro_job_level_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.jobRoleLevelList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.jobRoleLevelList, recordData?.job_role?.jro_job_level_id)}
						</label>
					}	                
				</FormItem>

				<FormItem className="font-medium mb-2 col-span-2"
					label="Target Date" 
					name="jrr_target_date"
					>
					{mode !== "view" ?
						<DatePicker id="jrr_target_date"
						className="input-field"
						format={DATE_FORMAT}
						style={{ width: "100%" }}
						/>
					: 
						<label className="text-base label-value dark:text-white">
							{recordData?.jrr_target_date}
						</label>
					}
				</FormItem>
			</div>
			<FormItem className="font-medium mb-2"
				label="Location"
				name="jro_location"
			>
				{mode !== 'view' ?
					<Input id="jro_location"
						className="input-field"
						type="text"
						placeholder="Enter location"
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{recordData?.job_role?.jro_location}
					</label>
				}
			</FormItem>
			<FormItem className="font-medium  mb-2 w-full"
				name="jro_job_description"
				label="Job Description"
			>
				{mode !== "view" ?
					<TextArea id="jro_job_description"
					className="input-field"
					rows={3}
					maxLength={500}		            		
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{recordData?.job_role?.jro_job_description}
					</label>
				}
			</FormItem>

			<DynamicList 
				name="jro_key_responsibilities"
				label="Key Responsibilities"
				placeholder="Enter responsibility"
				addButtonClass="text-gray-500 dark:text-white"
				mode={mode}
   				recordData={recordData?.job_role?.jro_key_responsibilities}
			/>

			<DynamicList 
				name="jro_preferred_qualifications"
				label="Preferred Qualifications"
				placeholder="Enter qualification"
				addButtonClass="text-gray-500 dark:text-white"
				mode={mode}
   				recordData={recordData?.job_role?.jro_preferred_qualifications}
			/>

			<FormItem className="font-medium  mb-2 w-full"
				name="jro_add_info"
				label="Additonal Information"
				>
				{mode !== "view" ?
					<TextArea id="jro_add_info"
					className="input-field"
					rows={3}
					maxLength={500}		            		
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{recordData?.job_role?.jro_add_info}
					</label>
				}
			</FormItem>


			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.jrr_id ?? 0}
						isModal={true}
						modalId={recordData?.jrr_id > 0 ? 'edit_job_role_request' : 'add_job_role_request'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
						moduleId={MODULE_JOBROLE_REQS}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.jobRoleRequest.jobRoleRequestDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getJobRoleRequestDetails(id)),
  	doCreate: (data) => dispatch(doJobRoleRequestCreate(data)),
  	doUpdate: (data) => dispatch(doJobRoleRequestUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleForm);
